// extracted by mini-css-extract-plugin
export default {"container":"DropdownFilter_container__cX2A6"};